import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import Menu from '@/views/Menu.vue';
import Rules from '@/views/Rules.vue';
import Prizes from '@/views/Prizes.vue';
import Gallery from '@/views/Gallery.vue';
import GalleryItem from '@/views/GalleryItem.vue';
import Quiz from '@/views/Quiz.vue';
import Winners from '@/views/Winners.vue';
import QuizInstructions from '@/views/QuizInstructions.vue';
import QuizGame from '@/views/QuizGame.vue';
import QuizEnd from '@/views/QuizEnd.vue';
import Contest from '@/views/Contest.vue';
// import ContestInstructions from '@/views/ContestInstructions.vue';
import ContestGame from '@/views/ContestGame.vue';
import ContestQuestion from '@/views/ContestQuestion.vue';
import ContestPersonal from '@/views/ContestPersonal.vue';
import ContestLegals from '@/views/ContestLegals.vue';
import ContestEnd from '@/views/ContestEnd.vue';
import ContestError from '@/views/ContestError.vue';
import Qr from '@/views/Qr.vue';
import Panel from '@/views/Panel.vue';
import PanelLogin from '@/views/PanelLogin.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({
    x: 0,
    y: 0,
  }),
  routes: [
    {
      path: '/home',
      name: 'Home',
      component: Home,
    },
    {
      path: '/menu',
      name: 'Menu',
      component: Menu,
    },
    {
      path: '/rules',
      name: 'rules',
      component: Rules,
    },
    {
      path: '/prizes',
      name: 'prizes',
      component: Prizes,
    },
    {
      path: '/gallery',
      name: 'gallery',
      component: Gallery,
    },
    {
      path: '/gallery/:entryId',
      name: 'gallery-item',
      component: GalleryItem,
      props: route => ({ entryId: route.params.entryId }),
    },
    {
      path: '/winners',
      name: 'winners',
      component: Winners,
    },
    {
      path: '/quiz',
      component: Quiz,
      children: [
        {
          path: '',
          redirect: 'instructions',
        },
        {
          path: 'instructions',
          name: 'quiz instructions',
          component: QuizInstructions,
        },
        {
          path: 'game',
          name: 'quiz game',
          component: QuizGame,
        },
        {
          path: 'end',
          name: 'quiz end',
          component: QuizEnd,
        },
      ],
    },
    {
      path: '/contest',
      component: Contest,
      children: [
        {
          path: '',
          redirect: 'game',
        },
        // {
        //   path: 'instructions',
        //   name: 'contest instructions',
        //   component: ContestInstructions,
        // },
        {
          path: 'game',
          name: 'contest game',
          component: ContestGame,
        },
        {
          path: 'question',
          name: 'contest question',
          component: ContestQuestion,
        },
        {
          path: 'personal',
          name: 'contest personal',
          component: ContestPersonal,
        },
        {
          path: 'legals',
          name: 'contest legals',
          component: ContestLegals,
        },
        {
          path: 'end',
          name: 'contest end',
          component: ContestEnd,
        },
        {
          path: 'error',
          name: 'contest error',
          component: ContestError,
          props: route => ({ backButtonTo: route.query.to }),
        },
      ],
    },
    {
      path: '/panel',
      component: Panel,
      children: [
        {
          path: '',
          redirect: 'login',
        },
        {
          path: 'login',
          name: 'login',
          component: PanelLogin,
        },
      ],
    },
    {
      path: '/qr',
      name: 'qr',
      component: Qr,
    },
    {
      path: '*',
      redirect: '/home',
    },
  ],
});
